import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from "@angular/forms";
import { InvoicesService } from '../../../../_services/invoices.service';
import { ParameterData, CustomValidators } from '../../../../_helpers/index';
import { Router } from '@angular/router';
import { DataService } from '../../../../_helpers/dataservice.service'
import { Invoice, Account, Debtor } from '../../../../_models';
import { CustomerService, DebtorDataService, DebtorService } from '../../../../_services';
import { currencysymbolPrefix } from '../../../../_enums/debtordocumenttype';
import { AppConfig } from '../../../../_helpers/index';
import { AuthService } from '../../../../_services/auth.service';
import * as moment from 'moment';
import { ReplaySubject, Subject } from 'rxjs';
import { debounceTime, delay, distinctUntilChanged, filter, map, takeUntil, tap } from 'rxjs/operators';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { AccountTypeOptions } from '../../../../sharedcomp/constans/routes.constans';
import { ConfigurationsKey } from 'src/app/_enums/configurations-key.enums';
import { validateMinimumPaymentValue, validateNoPreSelect } from '../../../form-validators/partial-payment-validator';
import { InvoicePaymentTypes } from 'src/app/_enums/invoice-payment-type-variables';

@Component({
    selector: 'invoicecreate',
    templateUrl: './invoicecreate.component.html'
})
export class InvoiceCreateComponent implements OnInit, OnDestroy, AfterViewInit {

    public customer_public_id: string;
    public user_public_id: string;
    public buttonValidate = false;


    public invoicePublic_key: any;
    public cusAccountPublicKey_temp: Account[] = [];
    public cusAccountPublicKey_ntemp: Account[] = [];
    public invoicePaymentTypes: Account[] = [];
    public cusDebtor: Debtor[] = [];
    public invoiceForm: FormGroup;
    public duedatetime: string;
    public name: string;
    submitted = false;
    due_datetime: any;
    ddltotalCurrencySymbol: any[];
    ddlLatefeeCurrencySymbol: any[];
    statusValue: any;
   // debPublicID: string;
    isalertVisiable = false;
    auth0Profile: any;

    isalertExist = false;
    statusExist;
    existLinkID;

    minDate: any;
    maxDate: any;
    maxDateVerificacion: any;
    maxVen: any;
    offsetTimeZone: any;
    offsetMinutes: any;
    offsetTimeVal: any;
    customerSearch: FormControl = new FormControl();
    filteredValue: ReplaySubject<Debtor[]> = new ReplaySubject<Debtor[]>(1);
    private _onDestroy = new Subject<void>();
    searching: boolean = false;
    noEntriesFoundLabel = "No results matched";
    preSelectDebtorDate: any;
    kashioApplication: any;
    customerFilterData: any[] =[];

    // Variable to show if invoice editing fails
    isErrorVisible: boolean;
    statusError: string;
    // Variable that will send the currency value to the accordion to set the form.
    currencySymbolInput: any;
    // Variable that will send the customer public Id Input() to the accordion.
    customerPublicIdInput: string;
    // Variable to indicate whether the account is CORPORATE or PAYMENTS
    APP: string;

    today;
    isDueDatetime: boolean = true;

    isInvoiceMinimumPaymentAvailable: boolean = false;

    private destroy$ = new Subject<void>();

    /** This is Constructor function which is used to initialize the class variables and objects; 
    */
    constructor
        (
            private router: Router, private _fb: FormBuilder
            , private parameterData: ParameterData, private dataService: DataService
            , private invoicesService: InvoicesService, private customerService: CustomerService
            , private _currencysymbolPrefix: currencysymbolPrefix
            , private _invoicePaymentTypes: InvoicePaymentTypes
            , private auth: AuthService
            , private debtorDataService:DebtorDataService
            , private spinnerService: Ng4LoadingSpinnerService
            , private debtorService: DebtorService
        ) {
        this.debtorDataService.getPreSelectDebtorSharedData().subscribe(data => this.preSelectDebtorDate = data);

        if (this.parameterData.InvoiceIdParameters !== null) {
            this.invoicePublic_key = this.parameterData.InvoiceIdParameters;
            this.parameterData.InvoiceIdParameters = null;
        } else {
            this.invoicePublic_key = "invoice Key";
        }

        this.isalertVisiable = false;

        this.ddltotalCurrencySymbol = _currencysymbolPrefix.currencyPrefix;
        this.ddlLatefeeCurrencySymbol = _currencysymbolPrefix.currencyPrefix;
        this.invoicePaymentTypes = _invoicePaymentTypes.invoicePaymentTypes;

        this.InitialSetup();

        var now = new Date();
        var todayDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        this.minDate = todayDate;

        var today = new Date();
        var lastDate = new Date(2050, 11, 31);
        this.maxDate = lastDate;

        const dueDate = new Date();
        var dateExp= new Date(this.duedatetime);
        var expDateLimit = new Date();
        this.maxDateVerificacion=new Date(expDateLimit.setDate(expDateLimit.getDate() + 30));
    }


    InitialSetup() {

        var currentDueDate = new Date();
        var currentExpDate = new Date();

        this.duedatetime = currentDueDate.toString();

        this.invoiceForm = this._fb.group({
            invoice_id: new FormControl(""),
            metadata: this._fb.group({
                order_id: new FormControl(""),
                order_name: new FormControl("", Validators.required),
                order_description: new FormControl("", Validators.maxLength(250))
            }),
            debtor: this._fb.group({
                public_id: new FormControl("", Validators.required),
                external_id: new FormControl(""),
                name: new FormControl(""),
                phone: new FormControl(""),
                email: new FormControl(""),
                document_type: new FormControl(""),
                document_id: new FormControl(""),
            }),
            total: this._fb.group({
                currency: new FormControl("Seleccione", Validators.required),
                value: new FormControl(0, [Validators.required, CustomValidators.total])
            }),

            due_datetime: new FormControl(new Date(currentDueDate)),
            late_fee: this._fb.group({
                currency: new FormControl("Seleccione"),
                value: new FormControl(0)
            }),

            expiration_datetime: new FormControl(new Date(currentExpDate.setDate(currentExpDate.getDate() + 30))),
            //                   
            creditor_account: this._fb.group({
                public_id: new FormControl("")
            }),
            user: this._fb.group({
                public_id: new FormControl("")
            }),
            sub_total: this._fb.group({
                currency: new FormControl("Seleccione", [Validators.required, validateNoPreSelect]),
                value: new FormControl(0, [Validators.required])
            }),
            fees: this._fb.group({
                currency: new FormControl(" "),
                value: new FormControl(0)
            })

        });
    }

    onDueDateChange(_event) {
        this.duedatetime = _event;
    }

    setSubTotalForm() {
        this.invoiceForm.get('sub_total.value').valueChanges.subscribe({
            next: sub_total => {

                // When the field is empty and has no value, any of these cases 
                // can result, so it is assigned the value 0
                if(isNaN(parseInt(sub_total)) || !sub_total || sub_total == "" ){
                    sub_total = 0;
                }

                sub_total = Number(sub_total);

                // I obtain the values of late_ fee and fees and then with the value of sub_total I make the 
                // calculation and assign this new value to total.
                const late_fee = this.invoiceForm.get('late_fee.value').value;
                const fees = this.invoiceForm.get('fees.value').value;

                // parseFloat() is used instead of parseInt() to handle decimals.
                const result =  parseFloat(sub_total) + parseFloat(late_fee) + parseFloat(fees);

                 this.invoiceForm.get('total.value').setValue(result);
            }
        });

        this.invoiceForm.get('sub_total.currency').valueChanges.subscribe({
            next: sub_total => {
                this.currencySymbolInput = sub_total;
                this.invoiceForm.get('late_fee.currency').setValue(sub_total);
                this.invoiceForm.get('fees.currency').setValue(sub_total);
                this.invoiceForm.get('total.currency').setValue(sub_total);
                if (this.invoiceForm.get('partial_payment')) {
                    this.invoiceForm.get('partial_payment.currency').setValue(sub_total);
                }
            }
        });
    }

    ngOnInit() {
        window.scroll(0, 0);
        this.APP = localStorage.getItem('application');
        var browserStorage;
        let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
        if (browserStorage1 == null) {
             browserStorage = localStorage.getItem('companyId');
            if (browserStorage == null || browserStorage == '' || browserStorage == undefined) {
                this.router.navigate(['/home']);
            } else {
                this.customer_public_id = localStorage.getItem('companyId');
                this.user_public_id = localStorage.getItem('userId');
            }
        } else {
            this.customer_public_id = localStorage.getItem('subcompanyId');
            this.user_public_id = localStorage.getItem('userId');
        }

        browserStorage = (typeof localStorage === 'undefined') ? null : localStorage;
        this.kashioApplication = localStorage.getItem('application');

        this.offsetTimeZone = (typeof browserStorage.getItem('timezone') === 'undefined') ? null : browserStorage.getItem('timezone');
        if (this.offsetTimeZone == null || this.offsetTimeZone === 'undefined' || Number.isNaN(this.offsetTimeZone)) {

            this.offsetTimeZone = -5.00;
            this.offsetMinutes = 0;
            this.offsetTimeVal = (this.offsetTimeZone * 3600000);
            AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal;
        } else {

            this.offsetTimeZone = browserStorage.getItem('timezone');
            this.offsetMinutes = 0;

            this.offsetTimeVal = (this.offsetTimeZone * 3600000);
            AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal;
        }

        if(this.preSelectDebtorDate !== undefined && this.preSelectDebtorDate !== null && this.preSelectDebtorDate !== 0){
            this.debtorService.getDebtor(this.preSelectDebtorDate.public_id).subscribe((data: Debtor) => {
                if (data.status == 'ACTIVE') {
                    var tempPreSelectData = [{ name: this.preSelectDebtorDate.name, public_id: this.preSelectDebtorDate.public_id }]
                    this.filteredValue.next(tempPreSelectData);
                    this.invoiceForm.get('debtor.public_id').setValue(this.preSelectDebtorDate.public_id);
                    this.invoiceForm.get('debtor.name').setValue(this.preSelectDebtorDate.name);
                    this.invoiceForm.get('debtor.external_id').setValue(data.external_id);
                    this.invoiceForm.get('debtor.phone').setValue(data.phone);
                    this.invoiceForm.get('debtor.document_type').setValue(data.document_type);
                    this.invoiceForm.get('debtor.document_id').setValue(data.document_id);
                    this.invoiceForm.get('debtor.email').setValue(data.email);
                    this.debtorDataService.setPreSelectDebtorSharedData(null);
                }
            })
        }
        var currentDueDate = new Date();

        this.customerPublicIdInput = this.customer_public_id;

        setTimeout(() => {
            this.customerService.getCustomerAccountList(this.customer_public_id).subscribe(data => {
                this.cusAccountPublicKey_temp = data;
                if(this.kashioApplication === "PAYOUTS"){
                    this.cusAccountPublicKey_temp = this.cusAccountPublicKey_temp.filter((t => t.type == 'PAYABLE'));
                }else{
                    this.cusAccountPublicKey_temp = this.cusAccountPublicKey_temp.filter((t => t.type == 'COLLECT' || t.type == 'RECEIVABLE'));
                }

                if (this.cusAccountPublicKey_temp != undefined && this.cusAccountPublicKey_temp != null) {
                    const cusAccountPublicKey_tempLength = this.cusAccountPublicKey_temp.length;
                    this.invoiceForm.get('late_fee.currency').setValue(this.cusAccountPublicKey_temp[0].balance.currency);
                    // // If the account is bi-currency, the select value of the total field will be set to "Seleccione".
                    cusAccountPublicKey_tempLength > 1 ? "" : this.setCurrency(this.invoiceForm, this.cusAccountPublicKey_temp[0].balance.currency);
                }
            });
        }, 500);
        
        this.getPartialPaymentsConfiguration(this.customer_public_id, ConfigurationsKey.PARTIAL_PAYMENTS);

        if (this.invoicePublic_key != null && this.invoicePublic_key != 'invoice Key') {
            this.invoicesService.getInvoice(this.invoicePublic_key).subscribe({
                next: invoice => {
                    this.name = invoice.name;
                    this.due_datetime = invoice.due_datetime;

                    this.invoiceForm.patchValue({
                        invoice_id: "",
                        metadata: {
                            order_id: invoice.metadata.order_id,
                            order_name: invoice.name,
                            order_description: invoice.metadata.order_description
                        },
                        debtor: {
                            public_id: invoice.debtor.public_id,
                        },
                        sub_total: {
                            currency: invoice.total.currency,
                            value: invoice.total.value
                        },
                        total: {
                            currency: invoice.total.currency,
                            value: invoice.total.value
                        },
                        due_datetime: new Date(currentDueDate),
                        late_fee: {
                            currency: invoice.late_fee.currency,
                            value: invoice.late_fee.value
                        },
                        fees: {
                            currency: invoice.fees.currency,
                            value: invoice.fees.value
                        },
                        expiration_datetime: new Date(invoice.expiration_datetime.replace(/-/g, "/")).toISOString(),
                        creditor_account:{
                            public_id: invoice.creditor_account == undefined ? '' : invoice.creditor_account.public_id
                        },
                        user: {
                            public_id: ""
                        }
                    });
                    this.spinnerService.hide();
                }, 
                complete: () => {
                    this.setSubTotalForm();
                }
            })
        }

        this.customerSearch
            .valueChanges
            .pipe(debounceTime(500),takeUntil(this._onDestroy))
            //.pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
                this.search();
            });
        
        this.invoiceForm.enable();

        this.today = moment(new Date()).format('YYYY/MM/DD');
    }

    //  forms' setters and getters 
    get paymentMethod(): string { return this.invoiceForm.get('payment_method').value; }

    paymentTypeChange(event: string) {
        const totalCurrency = this.invoiceForm.get('total.currency').value;
        
        if (event === 'partial_payment') {
            this.invoiceForm.controls['partial_payment'].get('min_amount').enable();
            this.invoiceForm.get('partial_payment.currency').setValue(totalCurrency);
            this.invoiceForm.get('partial_payment.min_amount').setValidators(validateMinimumPaymentValue);
        } else {
            this.invoiceForm.get('partial_payment.min_amount').clearValidators();
            this.invoiceForm.get('partial_payment.min_amount').setValue(0);
            this.invoiceForm.controls['partial_payment'].get('min_amount').disable();
        }

        this.invoiceForm.get('partial_payment.active').setValue(event === 'partial_payment');
        this.invoiceForm.get('partial_payment.min_amount').updateValueAndValidity();
    }

    setTotalFormListener() {
        this.invoiceForm.get('total.value').valueChanges.pipe(
            takeUntil(this.destroy$),
            tap(value => {
                const paymentType = this.paymentMethod === 'partial_payment';
                if (this.isInvoiceMinimumPaymentAvailable && paymentType) {
                    this.updateMinimumPaymentValidity()
                }
            })
        ).subscribe();
    }

    updateMinimumPaymentValidity() { 
        if (this.invoiceForm.get('partial_payment')) {
            this.invoiceForm.get('partial_payment.min_amount').updateValueAndValidity();
        }
    }

    getPartialPaymentsConfiguration(customerId: string, configurationUrl: (typeof ConfigurationsKey)[keyof typeof ConfigurationsKey]) {
        this.invoicesService.getInvoiceConfiguration(customerId, configurationUrl)
            .pipe(
                filter(val => val.values !== undefined && val.values.active !== undefined && val.values.active),
                map(val => val.values.active),
                tap(active => {
                    this.isInvoiceMinimumPaymentAvailable = active;
                    if (this.isInvoiceMinimumPaymentAvailable) {
                        this.invoiceForm.addControl('payment_method', new FormControl('total_payment'));
                        this.invoiceForm.addControl('partial_payment', this._fb.group({
                            currency: ['Seleccione', Validators.required],
                            active: [false],
                            min_amount: [0, [Validators.required]],
                        }));
                        this.invoiceForm.controls['partial_payment'].get('currency').disable();
                        this.invoiceForm.controls['partial_payment'].get('min_amount').disable();
                        this.setTotalFormListener();
                    }
                })
            )
            .subscribe();
    }
    
    setCurrency(form: FormGroup, parameter: string) {
        form.get('late_fee.currency').setValue(parameter);
        form.get('fees.currency').setValue(parameter);
        form.get('sub_total.currency').setValue(parameter);
        form.get('total.currency').setValue(parameter);
        if (form.get('partial_payment')) {
            form.get('partial_payment.currency').setValue(parameter);
        }
    }

    addDueDateTimeEvent(event) {
        if (event.value !== null) {
            const dueDatetimeSelected = (event.value).format('YYYY/MM/DD');
            const daysDifference = moment(dueDatetimeSelected).diff(moment(this.today), 'days');

            if (Math.sign(daysDifference) === -1) {
                this.isDueDatetime = false;
            } else {
                this.isDueDatetime = true;
                this.maxDateVerificacion=dueDatetimeSelected;
            }

        } else {
            this.isDueDatetime = true;
        }
    }

    addDueDateTimeEventExpiration(event) {
        if (event.value !== null) {
            const dateVen = this.invoiceForm.get('due_datetime').value;
            const dateExpiration = this.invoiceForm.get('expiration_datetime').value;
            this.maxVen=(dateVen);
            const dueDatetimeSelected = (event.value).format('YYYY/MM/DD');
            const daysDifference = moment(dueDatetimeSelected).diff(moment(this.today), 'days');
            this.maxDateVerificacion = new Date(dueDatetimeSelected);
            if (Math.sign(daysDifference) === -1) {
            } else {
            }
        } 
    }
    // After the view is rendered, I set up the change listener.
    ngAfterViewInit() {
        this.setSubTotalForm();
    }

    async search() {
        if (this.customerSearch.value.length > 2) {
            this.invoiceForm.get('debtor.public_id').setValue('');
            this.searching = true;
            this.noEntriesFoundLabel = "No results matched " + '"' + this.customerSearch.value + '"';
            try {
                const data = await this.customerService.getCustomerListBySearch(this.customer_public_id, this.customerSearch.value).toPromise();
                this.customerFilterData = data.data;
                this.filteredValue.next(this.customerFilterData.filter(item => item.status == 'ACTIVE'));
                this.searching = false;
            }
            catch (error) {
                console.log('Failed while trying to get the customer list.' + error.error)
            }
        } 
    }

    ngOnDestroy() {
        this.dataService.changeinvoicepublicKey('invoice Key');
        this._onDestroy.next();
        this._onDestroy.complete();
    }

    convertISO(convertExpDate) {

        var a = convertExpDate.split(/[- :]/),
            isoDate = new Date(a[0], a[1] - 1, a[2], a[3], a[4], a[5]);

        return new Date(isoDate).toISOString();
    }
    checkCurrencyDetails(value) {

        if (this.invoiceForm.get('total.currency').value != value) {
            alert("Please select the Currency same Mora and Monto")
        }

    }

    // Function that receives the values emitted from the Output() of the accordion. 
    setDataForm(data: any) {

        // When the field is empty and has no value is assigned the value 0

        if (isNaN(parseFloat(data.late_fee.value))){
            data.late_fee.value = 0;
        } else if (isNaN(parseFloat(data.fees.value))) {
            data.fees.value = 0;
        }

        // Whether the Output data is modified to 0 or not, these values are assigned
        //  to the fields of the form
        this.invoiceForm.get('late_fee.currency').setValue(data.late_fee.currency);
        this.invoiceForm.get('late_fee.value').setValue(data.late_fee.value);

        this.invoiceForm.get('fees.currency').setValue(data.fees.currency);
        this.invoiceForm.get('fees.value').setValue(data.fees.value);
     
        // When the field is empty and has no value, any of these cases 
        // can result, so it is assigned the value 0
        let sub_total = this.invoiceForm.get('sub_total.value').value;
        if(isNaN(parseFloat(sub_total)) || !sub_total || sub_total == "" ){
            sub_total = 0;
        }

        sub_total = Number(sub_total);
    
         // I obtain the values of late_ fee and fees and then with the value of sub_total I make the 
        // calculation and assign this new value to total.
        // parseFloat() is used instead of parseInt() to handle decimals.
        const result = parseFloat(sub_total) + parseFloat(data.late_fee.value) + parseFloat(data.fees.value);
        this.invoiceForm.get('total.value').setValue(result);
    }
    
    setNewInvoiceForm(value) {
        let { payment_method, partial_payment, metadata, ...invoiceObj } = value;
        let newMetadata = { ...metadata, partial_payment };
        return { ...invoiceObj, metadata: newMetadata };
    }

    /** This is onsubmit function called for all Invoice Data Save/Update Component; 
     */
    onsubmit(invoiceForm: FormGroup) {
        const value = invoiceForm.value;
        this.buttonValidate = true;

        this.cusAccountPublicKey_ntemp = this.cusAccountPublicKey_temp.filter((t => t.balance.currency == value.total.currency));

        value.creditor_account.public_id = this.cusAccountPublicKey_ntemp[0].public_id;

        const debtorInfo = this.customerFilterData.find(debtor => debtor.public_id === value.debtor.public_id);
        if (debtorInfo) {
            value.debtor.external_id = debtorInfo.external_id;
            value.debtor.name = debtorInfo.name;
            value.debtor.phone = debtorInfo.phone;
            value.debtor.email = debtorInfo.email;
            value.debtor.document_type = debtorInfo.document_type;
            value.debtor.document_id = debtorInfo.document_id;
        }
        var momentObj = moment(value.due_datetime);
        var dueDate = momentObj.format("YYYY-MM-DD 00:00:00");

        let dueDateGMT = this.convertGMTTime(dueDate);


        var dateObjexp = new Date(value.expiration_datetime);
        var momentObjexp = moment(dateObjexp);

        var expDate = momentObjexp.format('YYYY-MM-DD 00:00:00');

        let expDateGMT = this.convertGMTTime(expDate);


        value.due_datetime = dueDateGMT.replace(' ', 'T');
        value.expiration_datetime = expDateGMT.replace(' ', 'T');

        if (value.total.currency == 'S/.') {
            value.late_fee.currency = 'PEN';
            value.late_fee.value = Number(value.late_fee.value);
            value.total.currency = 'PEN';
            value.total.value = Number(value.total.value);
        }

        if (value.total.currency == 'US$') {
            value.late_fee.currency = 'USD';
            value.late_fee.value = Number(value.late_fee.value);
            value.total.currency = 'USD';
            value.total.value = Number(value.total.value);
        }
        value.late_fee.value = Number(value.late_fee.value);
        value.total.value = Number(value.total.value);

        value.user.public_id = this.user_public_id;

        if (value.id === null) {
            value.id = 0;
        }

        value.late_fee.currency = value.total.currency;

        // set payment_method propertie in metadata object with spread operator
        const newInvoiceForm = this.setNewInvoiceForm(value);
        if (value.total.currency == value.late_fee.currency) {
            this.invoicesService.createInvoice(newInvoiceForm)
                .subscribe({
                    next: result => {
                        var resultId = result["body"];
                        if (result.status == '200') {
                            this.statusExist = "Orden de Pago con este ID ya existe";
                            this.isalertExist = true;
                            this.existLinkID = resultId.public_id;
                        } else if(result.status == '202') {
                            if(result["body"]) {
                                this.statusError = result["body"];
                                this.isErrorVisible = true;
                            }
                        } else {       
                            this.invoiceForm.reset();
                            this.invoiceForm.enable();
                            this.statusValue = "La información fue creada correctamente !";
                            this.isalertVisiable = true;

                            if (AccountTypeOptions[this.APP] != undefined) {
                              this.router.navigate([`/${AccountTypeOptions[this.APP]}/invoices/${resultId.public_id}/view`]);
                            }
                        }
                    }, error: err => {
                        // If invoice editing fails, code 400 will be generated, so the message will be assigned to "statusError" for rendering in the HTML 
                        // and "isErrorVisible" will be set to true, complying with the *ngIf condition.
                        if (err.status == '400') {

                            this.statusError =  err.error;
                            
                            if(err.error && err.error.Description) {
                                this.statusError =  err.error.Description;
                            } else {
                                this.statusError = "Error al crear la orden de pago";
                            }

                            this.isErrorVisible = true;
                        };

                        console.log('Failed while trying to create the Invoice Details.' + err);
                    }
                });
        } else {
            this.statusValue = "Please select the Currency same Mora and Monto!";
            this.isalertVisiable = true;
        }
    }


    /****GMT Converstion */
    convertGMTTime(convertDate) {
        var dateTimeZoneDiff = convertDate.split(/[- :]/),
            startDateFinal = new Date(dateTimeZoneDiff[0], dateTimeZoneDiff[1] - 1, dateTimeZoneDiff[2], dateTimeZoneDiff[3], dateTimeZoneDiff[4], dateTimeZoneDiff[5]);
        if (this.offsetTimeZone > 0) {
            this.offsetMinutes = 30;
            var startDate2 = new Date(startDateFinal.setHours(startDateFinal.getHours() - this.offsetTimeZone));
            var startDate3 = new Date(startDate2.setMinutes(startDate2.getMinutes() - this.offsetMinutes) + 720000);
            let tempDate = moment(startDate3).format('YYYY-MM-DD HH:mm:ss');
            return tempDate;
        }
        else {
            var startDate4 = new Date(startDateFinal.setHours(startDateFinal.getHours() - this.offsetTimeZone));
            var startDate5 = new Date(startDate4.setMinutes(startDate4.getMinutes() - this.offsetMinutes));
            let tempDate1 = moment(startDate5).format('YYYY-MM-DD HH:mm:ss');
            return tempDate1;
        }


    }


    viewInvoiceList() {
        if (AccountTypeOptions[this.APP] != undefined) {
          this.router.navigate([`/${AccountTypeOptions[this.APP]}/invoices`]);
        }
    }

    viewInvoiceDetails() {
        if (AccountTypeOptions[this.APP] != undefined) {
          this.router.navigate([`/${AccountTypeOptions[this.APP]}/invoices/${this.existLinkID}/view`]);
        }
    }


}//end class


